import React, { useState, useEffect, useContext } from 'react';
import {
  Box,
  Tabs,
  Tab,
  Card,
  CardContent,
  Typography,
  Button,
  Select,
  MenuItem,
  Collapse,
  IconButton,
  Stack,
  Paper,
  Fab,
} from '@mui/material';

import { Skeleton, Container } from '@mui/material';
import {
  fetchSubscriptionsData,
  fetchTrainingsData,
  registerTransaction,
  sendReservations,
  getMerchantId,
  fetchProfileData,
  cancelTraining,
} from '../api';
import TrainingModal from './TrainingModal';
import handlePayment from '../payment.js';
import CancelTrainingDialog from './CancelTrainingDialog';
import { AuthContext } from '../../contexts/AuthContext';
import { PlaceContext } from '../../contexts/PlaceContext';
import { useHookState } from '../NotificationApiHook';
import { useNotification } from '../NotificationContext';
import { useDatePickerStyles } from '../DatePickerStyles';
import { getTime } from '../features/Bookings/utils';
import SubscriptionList from './SubscriptionList';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';
const Subscriptions = () => {
  const currentDate = new Date();

  let currentYear = currentDate.getFullYear();

  // Функция для генерации следующих трех месяцев
  const generateNextThreeMonths = () => {
    const months = [];
    let currentMonth = currentDate.getMonth();

    for (let i = 0; i < 3; i++) {
      if (currentMonth > 11) {
        currentMonth = 0;
        currentYear++;
      }
      const month = new Date(currentYear, currentMonth);
      months.push(month);
      currentMonth++;
    }
    return months;
  };

  const months = generateNextThreeMonths();

  // Функция для генерации всех дней выбранного месяца, начиная с текущей даты
  const generateDaysForMonth = (month, year) => {
    const firstDayOfMonth = new Date(year, month.getMonth(), 1);
    const lastDayOfMonth = new Date(year, month.getMonth() + 1, 0);
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Обнуляем часы, минуты, секунды и миллисекунды иначе не вз
    const days = [];
    let currentDate = new Date(firstDayOfMonth);

    // Добавляем только дни, начиная с текущей даты
    while (currentDate <= lastDayOfMonth) {
      if (currentDate >= today) {
        days.push(new Date(currentDate));
      }
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return days;
  };

  const [profileData, setProfileData] = useState(null);
  const [subscriptions, setSubscriptions] = useState([]);
  const [selectedTab, setSelectedTab] = useState(0);
  const { isLoggedIn, token } = useContext(AuthContext);
  const isAdmin = localStorage.getItem('role_id') === '1';
  const isCoach = localStorage.getItem('role_id') === '3';
  const [loading, setLoading] = useState(false);
  const { placeId } = useContext(PlaceContext);
  const { openNotification } = useNotification();
  const { notificationState } = useHookState();
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedTraining, setSelectedTraining] = useState(null);
  const [trainings, setTrainings] = useState([]);
  const [selectedDay, setSelectedDay] = useState(new Date());
  const [selectedMonthIndex, setSelectedMonthIndex] = useState(0);
  const { styles, dayButtonClass } = useDatePickerStyles();
  const [selectedMonthDays, setSelectedMonthDays] = useState(
    generateDaysForMonth(months[0], months[0].getFullYear()),
  );
  const isMobile = useMediaQuery('(max-width:600px)');
  const [expanded, setExpanded] = useState(false);
  const theme = useTheme();
  const [confirmCancelDialogOpen, setConfirmCancelDialogOpen] = useState(false);
  const [trainingToCancel, setTrainingToCancel] = useState(null);

  const handleOpenCancelDialog = (training) => {
    setTrainingToCancel(training);
    // Fetch players or prepare the list of players for the cancel dialog if needed
    // Example: setPlayersForCancel(playersData)
    setConfirmCancelDialogOpen(true);
  };

  const handleCloseCancelDialog = () => {
    setConfirmCancelDialogOpen(false);
    setTrainingToCancel(null);
  };

  const handleConfirmCancel = async (applyToAll) => {
    if (trainingToCancel) {
      const cancelData = applyToAll
        ? {
            place_id: placeId,
            info: trainingToCancel.info,
            for_all: true,
            day: trainingToCancel.day.replace(/"/g, ''),
          }
        : {
            id: trainingToCancel.id,
          };
      await handleCancelTraining(cancelData);
      handleCloseCancelDialog();
    }
  };

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const handleDateTabChange = (event, newMonth) => {
    setSelectedMonthIndex(newMonth);
    const daysForSelectedMonth = generateDaysForMonth(
      months[newMonth],
      months[newMonth].getFullYear(),
    );
    setSelectedMonthDays(daysForSelectedMonth);
    setSelectedDay(daysForSelectedMonth[0]);
  };

  const handleDaySelect = async (day) => {
    setSelectedDay(day);
  };

  useEffect(() => {
    fetchSubscriptionsData(placeId)
      .then((data) => setSubscriptions(data))
      .catch((error) => console.error('Error fetching subscriptions:', error));
  }, []);

  useEffect(() => {
    fetchTrainingsData(placeId, selectedDay.toLocaleDateString('ru-RU'))
      .then((data) => setTrainings(data))
      .catch((error) => console.error('Error fetching trainings:', error));
  }, [selectedDay]);

  useEffect(() => {
    fetchProfile();
  }, [isLoggedIn]);

  const fetchTrainings = () => {
    fetchTrainingsData(placeId, selectedDay.toLocaleDateString('ru-RU'))
      .then((data) => setTrainings(data))
      .catch((error) => console.error('Error fetching trainings:', error));
  };

  const fetchSubscriptions = () => {
    fetchSubscriptionsData(placeId)
      .then((data) => setSubscriptions(data))
      .catch((error) => console.error('Error fetching subscriptions:', error));
  };

  const fetchProfile = () => {
    if (token && placeId) {
      fetchProfileData(token, notificationState, 0, placeId)
        .then((data) => {
          setProfileData(data);
        })
        .catch((error) => {
          console.error('Ошибка при получении профиля:', error);
        });
    } else {
      setProfileData(null); // Обнуляем данные профиля, если токен отсутствует
    }
  };
  const handleOpenDialog = (training) => {
    setSelectedTraining(training);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    fetchProfile();
    fetchTrainings();
    setSelectedTraining(null);
    setOpenDialog(false);
  };

  const handleTabChange = (event, newTab) => {
    fetchProfile();
    fetchTrainings();
    fetchSubscriptions();
    setSelectedTab(newTab);
  };

  const resolveTransaction = async (status) => {
    try {
      if (status.total_price === 0) {
        openNotification(
          `Покупка абонемента подтверждена и оплачена с баланса вашего профиля`,
          'success',
        );
      } else {
        setLoading(true);
        const isSuccess = await sendReservations(token, status, notificationState);
        if (!isSuccess) {
          console.log('Failed to send reservations.');
        }
      }
    } finally {
      setLoading(false);
    }
  };
  const handleCancelTraining = async (payload) => {
    setLoading(true);
    try {
      await cancelTraining(token, payload, notificationState).then(() => {
        fetchTrainings();
      });
    } finally {
      setLoading(false);
    }
  };

  const purchase = async (subscription) => {
    let payload = { id: subscription.id, sub_price_id: subscription.price_id, place_id: placeId };
    try {
      if (isAdmin) {
        const orderData = await registerTransaction(payload, token, notificationState, 'training');
        const { id: paymentId, order_id: orderId, total_price: totalPrice } = orderData;
        resolveTransaction({
          order_id: orderId,
          payment_id: paymentId,
          total_price: totalPrice,
          type: 'training',
        });
      } else {
        const orderData = await registerTransaction(payload, token, notificationState, 'training');
        const { id: paymentId, order_id: orderId, total_price: totalPrice } = orderData;
        // When money on balance is enougth
        if (totalPrice === 0) {
          debugger;
          resolveTransaction({
            order_id: orderId,
            payment_id: paymentId,
            total_price: totalPrice,
            type: 'training',
          });
        } else {
          // Otherwise payment page will be opened.
          await getMerchantId(placeId, token, notificationState)
            .then((data) => {
              const merchantId = data;
              handlePayment(
                paymentId,
                totalPrice,
                orderId,
                `Оплата абонемента, посещения: ${subscription.quantity}`,
                merchantId,
              )
                .then(() => {
                  resolveTransaction({
                    order_id: orderId,
                    payment_id: paymentId,
                    total_price: totalPrice,
                    type: 'training',
                  });
                })
                .catch(() => {
                  console.error('Failed while payment.');
                  resolveTransaction({
                    order_id: orderId,
                    payment_id: paymentId,
                    total_price: totalPrice,
                    type: 'training',
                  });
                });
            })
            .catch((error) => {
              console.error('Error fetching books for merchantId:', error);
            });
        }
      }
    } catch (error) {
      console.error('Ошибка при регистрации транзакции:', error);
    } finally {
      fetchProfile();
    }
  };

  const groupedSubscriptions = subscriptions.reduce((acc, sub) => {
    if (!acc[sub.id]) {
      acc[sub.id] = {
        ...sub,
        options: [],
      };
    }
    acc[sub.id].options.push({
      price_id: sub.price_id,
      price: sub.price,
      quantity: sub.quantity,
      free_cancels: sub.free_cancels,
      due_days: sub.due_days,
      pricePerTraining: sub.price / sub.quantity,
    });
    return acc;
  }, {});

  const [selectedOptions, setSelectedOptions] = useState({});

  const handleOptionChange = (subscriptionId, newOption) => {
    setSelectedOptions((prevState) => ({
      ...prevState,
      [subscriptionId]: newOption,
    }));
  };

  // Функция для получения выбранной опции
  const getSelectedOption = (subscriptionId) => selectedOptions[subscriptionId] || {};

  if (!subscriptions && !trainings) {
    return (
      <Container sx={{ marginTop: '100px' }}>
        <Skeleton height={60} />
        <Skeleton height={60} />
        <Skeleton height={60} />
        <Skeleton height={60} />
        <Skeleton height={60} />
      </Container>
    );
  }

  // if ('True') {
  //   return (
  //     <div>
  //       <h1>Тренировки</h1>
  //       <p>Модуль с тренировками находится в разработке</p>
  //     </div>
  //   );
  // }

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Tabs
          value={selectedMonthIndex}
          onChange={handleDateTabChange}
          centered
        >
          {months.map((month, index) => (
            <Tab
              key={index}
              label={month.toLocaleDateString('ru-RU', { month: 'long' })}
            />
          ))}
        </Tabs>
      </Box>
      <Box
        key={selectedDay}
        mb={2}
        sx={{ display: 'flex', flexWrap: 'nowrap', overflowX: 'auto', ...styles.scrollbar }}
      >
        {selectedMonthDays.map((day) => (
          <Button
            key={day.toISOString()}
            variant='outlined'
            onClick={() => handleDaySelect(day)}
            sx={dayButtonClass}
          >
            <Typography
              variant='body2'
              className='day'
            >
              {day.toLocaleDateString('ru-RU', { weekday: 'short' })}
            </Typography>
            <Typography
              variant='body1'
              className={`date ${
                selectedDay && selectedDay.toDateString() === day.toDateString()
                  ? 'pressed'
                  : 'default'
              }`}
              data-locator='working_day_number'
            >
              {day.getDate()}
            </Typography>
          </Button>
        ))}
      </Box>
      <Tabs
        value={selectedTab}
        onChange={handleTabChange}
        centered
      >
        <Tab label='Тренировки' />
        <Tab label='Абонементы' />
      </Tabs>
      <Box
        sx={{
          padding: '4px 24px 0px 24px',
          maxHeight: 'calc(100svh - 370px)',
          minHeight: 'calc(100svh - 370px)',
          overflow: 'auto',
          ...styles.scrollbar,
        }}
      >
        {selectedTab === 1 && (
          <Box>
            {Object.keys(groupedSubscriptions).map((id) => {
              const subscription = groupedSubscriptions[id];
              const selectedOption = getSelectedOption(id);

              return (
                <Card
                  key={subscription.id}
                  sx={{ marginBottom: '16px' }}
                >
                  <CardContent>
                    <Typography
                      variant='h6'
                      component='div'
                      sx={{ mb: 1.5 }}
                    >
                      {subscription.subscription_name}
                    </Typography>
                    <Typography sx={{ mb: 1.5 }}>{subscription.info}</Typography>

                    <Typography sx={{ mb: 1.5 }}>
                      Бесплатные отмены:{' '}
                      <b> {selectedOption.free_cancels || subscription.options[0].free_cancels}</b>
                    </Typography>
                    <Typography sx={{ mb: 1.5 }}>
                      Cрок действия:{' '}
                      <b>{selectedOption.due_days || subscription.options[0].due_days} дней</b>
                    </Typography>
                    <Typography>
                      Цена одной тренировки:{' '}
                      <b>
                        {selectedOption.pricePerTraining ||
                          subscription.options[0].pricePerTraining}{' '}
                        рублей
                      </b>
                    </Typography>

                    <Select
                      value={selectedOption.price_id || subscription.options[0].price_id}
                      onChange={(event) => {
                        const newOption = subscription.options.find(
                          (option) => option.price_id === event.target.value,
                        );
                        handleOptionChange(subscription.id, newOption);
                      }}
                      sx={{ marginTop: '16px', marginBottom: '16px', width: '100%' }}
                    >
                      {subscription.options.map((option) => (
                        <MenuItem
                          key={option.price_id}
                          value={option.price_id}
                        >
                          Посещения: {option.quantity}
                        </MenuItem>
                      ))}
                    </Select>

                    <Button
                      disabled={!isLoggedIn}
                      variant='contained'
                      color='primary'
                      onClick={() => purchase({ ...subscription, ...selectedOption })}
                    >
                      Купить за {selectedOption.price || subscription.options[0].price} рублей
                    </Button>
                  </CardContent>
                </Card>
              );
            })}
          </Box>
        )}
        {selectedTab === 0 && (
          <Box>
            {trainings.length === 0 && (
              <Box sx={{ width: '90%', margin: '0 auto', mt: 3 }}>
                <Paper
                  elevation={3}
                  sx={{ p: 2 }}
                >
                  <Typography
                    variant='h6'
                    sx={{ textAlign: 'center' }}
                  >
                    Сегодня нет ни одной тренировки
                  </Typography>
                  <Typography
                    variant='body1'
                    sx={{ textAlign: 'center' }}
                  >
                    Выберите другой день
                  </Typography>
                </Paper>
              </Box>
            )}
            {trainings.map((training) => (
              <Card
                key={training.id}
                sx={{ marginBottom: '16px' }}
                onClick={() => handleOpenDialog(training)}
              >
                <CardContent>
                  <Typography
                    variant='h6'
                    component='div'
                  >
                    {training.info}
                  </Typography>
                  <Typography
                    sx={{ mb: 1.5 }}
                    color='text.secondary'
                  >
                    Тренер: {training.coach_name}
                  </Typography>
                  <Typography
                    sx={{ mb: 1.5 }}
                    color='text.secondary'
                  >
                    Время начала: {getTime(training.start_time)}
                  </Typography>
                  <Typography
                    sx={{ mb: 1.5 }}
                    color='text.secondary'
                  >
                    Участники: {training.players}/{training.quantity}
                  </Typography>
                  <Typography variant='body2'></Typography>
                  {(isCoach || isAdmin) && (
                    <Button
                      variant='contained'
                      color='error'
                      onClick={(e) => {
                        e.stopPropagation();
                        handleOpenCancelDialog(training);
                      }}
                    >
                      Отменить тренировку
                    </Button>
                  )}
                </CardContent>
              </Card>
            ))}
          </Box>
        )}
        <TrainingModal
          open={openDialog}
          onClose={handleCloseDialog}
          training={selectedTraining}
          profile={profileData}
          selectedDay={selectedDay}
          placeId={placeId}
        />
      </Box>
      {!isLoggedIn && (
        <Fab
          color='primary'
          disabled={!isLoggedIn}
          sx={{
            backgroundColor: theme.palette.primary.main,
            position: 'sticky',
            bottom: '58px',
            marginLeft: isMobile ? '0' : 'calc(50% - 275px)',
            display: !isLoggedIn ? 'block' : 'none',
            width: '100%',
            maxWidth: '600px',
            height: '80px',
            lineHeight: '30px',
            padding: '15px',
            zIndex: '98',
            borderRadius: '0',
            '&.Mui-disabled': {
              backgroundColor: '#4b4b4b',
              color: theme.palette.primary.contrastText,
            },
          }}
        >
          <Box>Войдите в систему</Box>
        </Fab>
      )}
      {profileData?.subscriptions.length > 0 && (
        <Box
          sx={{
            padding: '3px 12px 10px 22px',
            backgroundColor: '#f5f5f5',
            position: 'sticky',
            bottom: 60,
          }}
        >
          <Stack
            direction='row'
            alignItems='center'
            gap={1}
            sx={{ mt: 1, justifyContent: 'space-between' }}
          >
            <Typography
              variant='h6'
              sx={{ fontSize: '1rem' }}
            >
              Действующие абонементы
            </Typography>
            <IconButton
              onClick={handleExpandClick}
              sx={{
                padding: '0',
                transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 0.3s',
              }}
            >
              <ExpandMoreIcon />
            </IconButton>
          </Stack>
          <Collapse
            in={expanded}
            timeout='auto'
            unmountOnExit
          >
            <SubscriptionList subscriptions={profileData?.subscriptions || []} />
          </Collapse>
        </Box>
      )}
      <CancelTrainingDialog
        open={confirmCancelDialogOpen}
        onClose={handleCloseCancelDialog}
        onConfirm={handleConfirmCancel}
        training={trainingToCancel}
      />
    </Box>
  );
};

export default Subscriptions;
